import { readFile } from "node:fs/promises";
import { resolve } from "node:path";
import type { Readable } from "node:stream";

import { CliError } from "../errors/index.js";
import { readStdin } from "./output.js";

function hasUrlProtocol(value: string) {
  return value.startsWith("http://") || value.startsWith("https://");
}

export async function resolveContentSpec(
  cwd: string,
  spec: string | undefined,
  stdin: Readable,
  options: {
    kind: string;
    required: boolean;
  },
) {
  if (spec !== undefined) {
    if (spec.startsWith("file:")) {
      const target = spec.slice("file:".length);
      if (target.length === 0) {
        throw new CliError("INVALID_CONTENT", "file: content spec requires a path");
      }
      return await readFile(resolve(cwd, target), "utf8");
    }

    if (hasUrlProtocol(spec)) {
      const response = await fetch(spec);
      if (!response.ok) {
        throw new CliError(
          "REMOTE_CONTENT_FAILED",
          `Unable to fetch content from ${spec}: ${response.status}`,
        );
      }
      return await response.text();
    }

    if (spec.startsWith(":")) {
      return spec.slice(1);
    }

    return spec;
  }

  const stdinContent = await readStdin(stdin);
  if (stdinContent.length > 0) {
    return stdinContent;
  }

  if (options.required) {
    throw new CliError(
      "EMPTY_INPUT",
      `${options.kind} expects content via stdin or a content spec`,
    );
  }

  return undefined;
}
